import VendorValidationRule from "../interfaces/VendorValidationRule";

class VendorValidationHelper {
    public static getRule = (programName: string): VendorValidationRule | undefined => {
        return VendorValidationHelper.rules[programName];
    };

    public static getRuleDescription = (programName: string): string | null => {
        const rule = VendorValidationHelper.getRule(programName);

        return rule ? rule.errorMsg : null;
    };

    public static validate = (programName: string, contractorId: string | null): string | null => {
        if (!contractorId || contractorId.trim() === "") {
            return "Contractor ID is required.";
        }

        const rule = VendorValidationHelper.getRule(programName);

        if (!rule) {
            return null;
        }

        if (!rule.regex.test(contractorId)) {
            return rule.errorMsg;
        }

        return null;
    };

    private static readonly rules: Readonly<Record<string, VendorValidationRule>> = {
        "TAMKO Edge": {
            regex: /^\d{6}$/,
            errorMsg: "TAMKO Contractor ID should be numerical and 6 digits in length.",
        },
        "GAF Rewards": {
            regex: /^\d{7}$/,
            errorMsg: "GAF Contractor ID should be numerical and 7 digits in length.",
        },
        "CertainTeed Contractor Cash Back": {
            regex: /^\d{7}$/,
            errorMsg: "CertainTeed Contractor ID should be numerical and 7 digits in length.",
        },
        "PlyGem Pro Solutions": {
            regex: /^[a-zA-Z0-9]{8}$/,
            errorMsg: "PlyGem Contractor ID uses an 8 digit alpha-numeric code.",
        },
        "The James Hardie™ ALLIANCE": {
            regex: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            errorMsg: "James Hardie Contractor ID should be an email address.",
        },
        "Wolf Home Products Rewards": {
            regex: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            errorMsg: "Wolf Contractor ID should be an email address.",
        },
        "Westlake Royal PROS Perks Program": {
            regex: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            errorMsg: "Westlake Contractor ID should be an email address.",
        },
        "Bostik Pro Rewards": {
            regex: /^[a-zA-Z0-9]{1,9}$/,
            errorMsg: "The Bostik Pro Rewards Contractor ID is alpha and numeric, up to 9 characters.",
        },
        "Andersen Certified Contractor Program": {
            regex: /^\d{6}$/,
            errorMsg: "The Andersen Trade ID should be a 6 digit numerical value.",
        },
        "Owens Corning Roofing Contractor Network": {
            regex: /^\d+$/,
            errorMsg: "The Owens Corning Roofing Contractor ID should be numerical.",
        },
        "Simonton ProNetwork": {
            regex: /^\d{8}$/,
            errorMsg: "The Simonton Contractor ID should be a 8 digit numerical value.",
        },
    };
}

export default VendorValidationHelper;
